import { SimpleInput } from '../../input'
import { DefaultBtn } from '../../buttons'
import { RenderImage } from './QuestionForm'
const MultipleChoice = (props) => {
  const {
    index,
    question,
    handleResponse,
    handleChange,
    remove,
    response,
    handleImg,
    onClose,
    handleImgChange,
  } = props
  function handleText() {
    handleImgChange(null, index, 'respImg', false)
  }
  function handleResp(values) {
    handleImgChange(values.ImageFile, index, 'respImg', true)
    onClose()
  }
  function handleCorrect(index) {
    let boolean = false
    question.correctId.forEach((e) => {
      if (e === index) {
        boolean = true
      }
    })
    return boolean
  }
  return (
    <div className="QuestionForm__response">
      <input
        type="checkbox"
        id={`radio${index}`}
        name="correctId"
        onChange={(event) => handleChange(event, index, true)}
        checked={handleCorrect(index)}
      />

      {question.respImg[index].isImage ? (
        <RenderImage file={question.respImg[index].file} />
      ) : (
        <SimpleInput
          name={index}
          type="text"
          label="Respuesta"
          onChange={handleResponse}
          value={response}
          err={response === '' ? 'Campo requerido' : ''}
        />
      )}
      <DefaultBtn
        width="100%"
        type="button"
        background={true}
        onClick={
          question.respImg[index].isImage
            ? handleText
            : () => handleImg(handleResp)
        }
      >
        <i
          className={
            question.respImg[index].isImage ? 'fas fa-heading' : 'far fa-image'
          }
        ></i>
      </DefaultBtn>
      {index > 0 && (
        <button type="button" onClick={() => remove(index)}>
          <i className="fas fa-times"></i>
        </button>
      )}
    </div>
  )
}

export default MultipleChoice
